import { render, staticRenderFns } from "./SinglePackage.vue?vue&type=template&id=518f36e4"
import script from "./SinglePackage.vue?vue&type=script&lang=js"
export * from "./SinglePackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports